import { jsx as _jsx } from "react/jsx-runtime";
var Star = function Star(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12 16.05c.159 0 .318.038.463.113l3.769 1.97-.717-4.157a.999.999 0 0 1 .29-.889l3.035-2.936-4.203-.612a.999.999 0 0 1-.752-.544L12 5.201l-1.886 3.794a.998.998 0 0 1-.751.544l-4.203.612 3.036 2.936a.999.999 0 0 1 .29.889l-.717 4.157 3.769-1.97c.144-.075.303-.113.462-.113Zm5.561 4.905a.996.996 0 0 1-.462-.113l-5.1-2.664-5.098 2.664a1 1 0 0 1-1.448-1.057l.972-5.628-4.12-3.985a.998.998 0 0 1 .55-1.708l5.702-.828 2.546-5.126c.338-.68 1.454-.68 1.793 0l2.546 5.126 5.701.828a.998.998 0 0 1 .551 1.708l-4.12 3.985.973 5.628a1 1 0 0 1-.986 1.17Z",
      fill: color
    })
  });
};
export default Star;